import React from "react";
import { X } from "lucide-react";

interface TimePickerModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedTime: string;
  onSelectTime: (time: string) => void;
}

const TimePickerModal: React.FC<TimePickerModalProps> = ({
  isOpen,
  onClose,
  selectedTime,
  onSelectTime,
}) => {
  const generateTimeSlots = () => {
    const slots: string[] = [];
    for (let hour = 9; hour <= 21; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const date = new Date(0, 0, 0, hour, minute);
        const timeString = date.toLocaleTimeString([], {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
        slots.push(timeString);
      }
    }
    return slots;
  };

  const timeSlots = generateTimeSlots();

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[60]"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] max-h-[600px] bg-white rounded-xl shadow-2xl z-[70] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-[#402B69]">Select Time</h3>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition"
          >
            <X size={20} className="text-gray-600" />
          </button>
        </div>

        {/* Time Slots Grid */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="grid grid-cols-3 gap-3">
            {timeSlots.map((time) => {
              const isSelected = time === selectedTime;
              return (
                <button
                  key={time}
                  onClick={() => {
                    onSelectTime(time);
                    onClose();
                  }}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition ${
                    isSelected
                      ? "bg-[#885ABB] text-white"
                      : "bg-[#F9F9F9] text-[#402B69] hover:bg-[#E8D9F5] hover:text-[#885ABB]"
                  }`}
                >
                  {time}
                </button>
              );
            })}
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-6 py-2 rounded-lg border border-[#C4A6E1] text-[#402B69] font-medium hover:bg-gray-50 transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default TimePickerModal;
